import React from 'react';
import axios from 'axios';
import { sanitizeInputAgainstXSS } from '../../../../../../util/sanitizeInputAgainstXSS';
import {
  validateInputOnBlur,
  validateInputOnInput,
  errorTypesText,
  emailValidation,
} from '../../../../../../util/validation';

export class SharedProductDisplayEcard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.state.sendDate = false;
    this.state.attemptedSubmit = false;
    this.state.formData = {
      selectedImage: {
        value: undefined,
        required: true,
        valid: true,
      },
      selectedAttrVal: {
        value: '*',
        required: true,
        valid: true,
      },
      recipName: {
        value: '',
        maxLength: 25,
        required: true,
        valid: true,
      },
      recipEmail: {
        value: '',
        maxLength: 50,
        required: true,
        valid: true,
      },
      recipEmailConfirm: {
        value: '',
        maxLength: 50,
        required: true,
        valid: true,
      },
      senderName: {
        value: '',
        maxLength: 25,
        required: true,
        valid: true,
      },
      senderMessage: {
        value: '',
        maxLength: 120,
        required: false,
        valid: true,
      },
      date: {
        value: '',
        valid: true,
        required: true,
      },
    };
    this.amountOnChange = this.amountOnChange.bind(this);
    this.imageOnChange = this.imageOnChange.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.updateFormInput = this.updateFormInput.bind(this);
    this.ajaxAddToBag = this.ajaxAddToBag.bind(this);

    this.handleInputBlur = this.handleInputBlur.bind(this);
    this.updateFormInputExpose = this.updateFormInputExpose.bind(this);
    this.amountOnChangeExpose = this.amountOnChangeExpose.bind(this);
    this.handleDateChangeExpose = this.handleDateChangeExpose.bind(this);
    this.imageOnChangeExpose = this.imageOnChangeExpose.bind(this);
    this.closeErrorMessage = this.closeErrorMessage.bind(this);

    this.errorVisible = false;
    this.errorScrolledTo = false;
    this.addToBagClicked = false;
  }
  componentDidMount() {
    window.eCardExpose = {};
    window.eCardExpose.updateFormInputExpose = this.updateFormInputExpose;
    window.eCardExpose.amountOnChangeExpose = this.amountOnChangeExpose;
    window.eCardExpose.handleDateChangeExpose = this.handleDateChangeExpose;
    window.eCardExpose.imageOnChangeExpose = this.imageOnChangeExpose;
  }
  updateFormInputExpose(inputName, inputValue) {
    // var rawInputValue = event.target.value;
    // var inputName = event.target.getAttribute('data-inputname');
    var fakeEvent = {};
    fakeEvent.target = {};
    fakeEvent.target.value = inputValue;
    fakeEvent.target.getAttribute = () => {
      return inputName;
    };
    this.updateFormInput(fakeEvent);
  }
  amountOnChangeExpose(amountValue) {
    // event.target.value
    var fakeEvent = {};
    fakeEvent.target = {};
    fakeEvent.target.value = amountValue;
    this.amountOnChange(fakeEvent);
  }
  handleDateChangeExpose(dateString) {
    //expects a moment, will fabricate one.
    this.handleDateChange(new Date(dateString));
  }
  imageOnChangeExpose(selectedImage) {
    // event.target.value
    var fakeEvent = {};
    fakeEvent.target = {};
    fakeEvent.target.value = selectedImage;
    this.imageOnChange(fakeEvent);
  }
  componentWillUnmount() {
    window.eCardExpose = false;
  }
  componentDidUpdate() {
    if ($('.error-tip').length > 0) {
      this.errorVisible = true;
    } else {
      this.errorVisible = false;
      this.errorScrolledTo = false;
    }

    if (this.errorVisible && this.addToBagClicked) {
      var firstErrorPosition = $('.error-tip').first().offset().top;
      $('html, body').animate(
        {
          scrollTop: firstErrorPosition - 300,
        },
        500
      );
      this.addToBagClicked = false;
    }
  }
  amountOnChange(event) {
    if (event.target.value == '*') {
      const formData = { ...this.state.formData };
      formData.selectedAttrVal = { value: '*', valid: false };
      this.setState({ formData });
    } else {
      var attributeVals = this.props.contentData.attributes[0].values;
      for (var iAttrVal = 0; iAttrVal < attributeVals.length; iAttrVal++) {
        var thisAttrVal = attributeVals[iAttrVal];
        if (thisAttrVal.value == event.target.value) {
          thisAttrVal.valid = true;
          this.state.formData['selectedAttrVal'] = thisAttrVal;
          this.setState({});
        }
      }
    }
  }

  handleInputBlur(e, type, required) {
    const val = e.target.value;
    const ansObj = { ...this.state.formData };
    const validation = validateInputOnBlur(val, type, required);
    ansObj[type].valid = validation.valid;
    ansObj[type].errorMsg = validation.errorMsg;

    if (type === 'recipEmailConfirm') {
      ansObj[type].valid = val === this.state.formData.recipEmail.value && val.length > 0;
    }
    if (type === 'recipEmail' && ansObj['recipEmail'].value !== ansObj['recipEmailConfirm'].value) {
      ansObj['recipEmailConfirm'].valid = false;
    }
    this.setState({ formData: ansObj });
  }
  imageOnChange(event) {
    const val = event.target.value;
    const ansObj = { ...this.state.formData };
    ansObj.selectedImage.valid = true;
    ansObj.selectedImage.value = val;
    this.setState({ formData: ansObj });
    this.slider.slideToLoop(event.target.value);
  }
  handleDateChange(returnedMoment) {
    var sendDate = returnedMoment;
    if ('Invalid Date' == new Date(sendDate) && returnedMoment.target && returnedMoment.target.defaultValue) {
      sendDate = returnedMoment.target.defaultValue;
    }

    if (
      new Date(sendDate) >= new Date(new Date().setHours(0, 0, 0, 0)) &&
      new Date(sendDate) < new Date(new Date().setFullYear(new Date().getFullYear() + 1))
    ) {
      this.state.formData.date.valid = true;
      this.state.formData.date.value = sendDate;
      this.setState({
        sendDate: returnedMoment,
      });
    } else {
      this.state.formData.date.valid = false;
    }
  }
  cleanseInput(inputString) {
    return inputString;
  }
  isValidEmail(testString) {
    var regEx =
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regEx.test(testString);
  }
  updateFormInput(e, type) {
    const val = e.target.value;
    const ansObj = { ...this.state.formData };
    const validation = validateInputOnInput(val, type);
    ansObj[type].value = validation.value;
    ansObj[type].valid = true;
    this.setState({ formData: ansObj });
    e.target.value = validation.value;
  }

  closeErrorMessage() {
    this.setState({ errorMessage: false });
  }
  ajaxAddToBag() {
    this.addToBagClicked = true;
    var formValid = true;

    this.handleDateChange(new Date($('#send-date').val()));

    //needed for adobe analytics
    var origCartQty =
      this.props.passedAppFunctions.myDillardsInfo &&
      this.props.passedAppFunctions.myDillardsInfo.miniCartInfo &&
      this.props.passedAppFunctions.myDillardsInfo.miniCartInfo.cartItemCount
        ? this.props.passedAppFunctions.myDillardsInfo.miniCartInfo.cartItemCount
        : '';

    if (this.state.formData.selectedImage.value === undefined) {
      const valObj = { ...this.state.formData };
      valObj.selectedImage.valid = false;
      this.setState({ formData: valObj });
      formValid = false;
    }

    const answersObj = this.state.formData;
    Object.keys(this.state.formData).forEach((q) => {
      if (
        answersObj[q].required === true &&
        (answersObj[q].value === undefined ||
          answersObj[q].value === '*' ||
          answersObj[q].value === '' ||
          q.includes('Email') ||
          answersObj[q].valid === false)
      ) {
        const ansObj = { ...answersObj };

        if (q.includes('Email') && (emailValidation(answersObj[q].value) === false || answersObj[q].valid === false)) {
          ansObj[q].valid = false;
          formValid = false;
        } else if (!q.includes('Email')) {
          ansObj[q].valid = false;
          ansObj[q].errorMsg = errorTypesText.required;
          formValid = false;
        }
        this.setState({ formData: ansObj });
      }
    });

    if (formValid) {
      this.props.passedAppFunctions.toggleTransition();
      var axiosOptions = {
        method: 'post',
        url: '/webapp/wcs/stores/servlet/OrderItemAdd?ak=n',
      };
      axiosOptions.data = 'storeId=301';
      axiosOptions.data += '&orderId=.';
      axiosOptions.data += '&catalogId=301';
      axiosOptions.data += '&URL=';
      axiosOptions.data += '&errorViewName=ProductDisplayEcardView';
      axiosOptions.data += '&productId=' + this.props.contentData.productId;
      axiosOptions.data += '&catEntryId=' + this.props.contentData.productId;
      axiosOptions.data += '&limitedAvailability=N';
      axiosOptions.data += `&description=${this.props.contentData.partNumber}|${this.props.contentData.productId}|${this.props.passedAppFunctions.getURLParamValue('categoryId') || '-10035'}|PP-PIP|N`;
      axiosOptions.data += '&rURL=' + this.props.contentData.productURL;
      axiosOptions.data += '&qty=1';
      axiosOptions.data += '&quantity=1';
      if (this.state.sendDate == null) {
        var today = new Date();
        var d = today.getDate();
        var m = today.getMonth() + 1;
        axiosOptions.data +=
          '&sendDate=' + today.getFullYear() + '-' + (m <= 9 ? '0' + m : m) + '-' + (d <= 9 ? '0' + d : d);
      } else {
        const [isoDate] = this.state.sendDate.toISOString().split('T');
        axiosOptions.data += '&sendDate=' + isoDate;
      }
      axiosOptions.data +=
        '&lineitemtype=' + this.props.contentData.ecardImages[this.state.formData.selectedImage.value].imageName;
      axiosOptions.data += '&attrName=' + this.props.passedFunctions.parentState.attributeState.attributes[0].attrId;
      axiosOptions.data += '&attrValue=' + this.state.formData.selectedAttrVal.value;
      axiosOptions.data += '&recipName=' + this.state.formData.recipName.value;
      axiosOptions.data += '&recipEmail=' + this.state.formData.recipEmail.value;
      axiosOptions.data += '&recipEmailConfirm=' + this.state.formData.recipEmailConfirm.value;
      axiosOptions.data += '&senderName=' + this.state.formData.senderName.value;
      axiosOptions.data += '&comment=' + sanitizeInputAgainstXSS(this.state.formData.senderMessage.value);
      axiosOptions.data += '&superAddedFrom=450';
      axiosOptions.data += '&returnJSON=true';

      axios(axiosOptions)
        .then((ajaxResponse) => {
          var cmdRespIsJSON;
          var responseJSON = {};
          try {
            responseJSON = typeof ajaxResponse.data == 'object' ? ajaxResponse.data : JSON.parse(ajaxResponse.data);
            cmdRespIsJSON = true;
          } catch (e) {}
          if (cmdRespIsJSON) {
            //update state with the new information
            responseJSON.selectedMainImg = `ecard_${this.props.contentData.ecardImages[this.state.formData.selectedImage.value].imageName}`;
            responseJSON.productNameForURL = this.props.contentData.productNameForURL;
            responseJSON.partNumber = this.props.contentData.partNumber;
            var dateToUse = new Date();
            if (this.state.sendDate != null) {
              dateToUse = this.state.sendDate;
            }
            var d = dateToUse.getDate();
            var m = dateToUse.getMonth() + 1;
            responseJSON.eCardDate =
              dateToUse.getFullYear() + '-' + (m <= 9 ? '0' + m : m) + '-' + (d <= 9 ? '0' + d : d);

            this.props.passedAppFunctions.toggleTransition();
            this.props.passedAppFunctions.setModalInfo(responseJSON);

            this.props.passedAppFunctions.setDataLayerInfo('itemAddedInfo', {
              childPartNumber: responseJSON.childPartnumberAdded || '',
              parentPartNumber: responseJSON.partNumber || '',
              quantityAdded: '1',
              priceAdded: responseJSON.amount || '',
              productName: this.props.contentData.productName
                ? this.props.contentData.productName
                    .split('#double;')
                    .join('"')
                    .split('-')
                    .join(' ')
                    .replace(/[^a-zA-Z 0-9]/g, '')
                : '',
            });

            try {
              if (origCartQty * 1 == 0) {
                this.props.passedAppFunctions.setDataLayerInfo('commerce', {
                  productListOpens: { value: 1 },
                  productListAdds: { value: 1 },
                });
              } else {
                this.props.passedAppFunctions.setDataLayerInfo('commerce', { productListAdds: { value: 1 } });
              }
            } catch (e) {
              this.props.passedAppFunctions.setDataLayerInfo('commerce', { productListAdds: { value: 1 } });
            }

            this.props.passedAppFunctions.setDataLayerInfo('productListItems', [
              {
                SKU: responseJSON.partNumber || '',
                quantity: '1',
                priceTotal: responseJSON.amount || '',
                name: this.props.contentData.productName
                  ? this.props.contentData.productName
                      .split('#double;')
                      .join('"')
                      .split('-')
                      .join(' ')
                      .replace(/[^a-zA-Z 0-9\&]/g, '')
                  : '',
              },
            ]);

            //MODAL
          } else {
            //something errored...
            this.props.passedAppFunctions.toggleTransition(false);
            this.setState({ errorMessage: 'There was an error adding this item to your bag. Please try again later.' });
          }
        })
        .catch((err) => {
          this.props.passedAppFunctions.toggleTransition(false);
          //something errored
          this.setState({ errorMessage: 'There was an error adding this item to your bag. Please try again later.' });
        });
    } else {
      this.setState({ attemptedSubmit: true });
    }
  }
}

export default SharedProductDisplayEcard;
